import { useEffect, useState } from 'react';

const cache = { result: null };

const US_TIMEZONES = [
	'America/New_York',
	'America/Detroit',
	'America/Kentucky/Louisville',
	'America/Kentucky/Monticello',
	'America/Indiana/Indianapolis',
	'America/Indiana/Vincennes',
	'America/Indiana/Winamac',
	'America/Indiana/Marengo',
	'America/Indiana/Petersburg',
	'America/Indiana/Vevay',
	'America/Chicago',
	'America/Indiana/Tell_City',
	'America/Indiana/Knox',
	'America/Menominee',
	'America/North_Dakota/Center',
	'America/North_Dakota/New_Salem',
	'America/North_Dakota/Beulah',
	'America/Denver',
	'America/Boise',
	'America/Phoenix',
	'America/Los_Angeles',
	'America/Anchorage',
	'America/Juneau',
	'America/Sitka',
	'America/Yakutat',
	'America/Nom',
	'America/Adak',
	'Pacific/Honolulu'
];

const isUSTimezone = () => {
	try {
		const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
		return US_TIMEZONES.includes(tz);
	} catch {
		return true;
	}
};

const fetchIPCountry = async () => {
	// Try ipwho.is (IP-based geolocation - respects VPNs and requires no permission prompt)
	try {
		const res = await fetch('https://ipwho.is/', { signal: AbortSignal.timeout(4000) });
		const data = await res.json();
		if (data && data.success !== false) {
			const countryCode = (data.country_code || data.countryCode)?.toUpperCase();
			if (countryCode) return countryCode === 'US';
		}
	} catch {
		// Fallback if ipwho.is is blocked or fails
	}

	// Try ip-api.com as secondary fallback
	try {
		const res = await fetch('http://ip-api.com/json/', { signal: AbortSignal.timeout(4000) });
		const data = await res.json();
		if (data && data.status === 'success') {
			const countryCode = data.countryCode?.toUpperCase();
			if (countryCode) return countryCode === 'US';
		}
	} catch {
		// Secondary fallback
	}

	// Fallback to timezone hint if network IP services fail
	return isUSTimezone();
};

const useIsUSD = () => {
	const [isUSD, setIsUSD] = useState(() => {
		if (cache.result !== null) return cache.result;
		return isUSTimezone();
	});

	useEffect(() => {
		if (cache.result !== null) {
			setIsUSD(cache.result);
			return;
		}

		let isMounted = true;
		fetchIPCountry()
			.then((usd) => {
				cache.result = usd;
				if (isMounted) setIsUSD(usd);
			})
			.catch(() => {
				const usd = isUSTimezone();
				cache.result = usd;
				if (isMounted) setIsUSD(usd);
			});

		return () => {
			isMounted = false;
		};
	}, []);

	return { isUSD };
};

export default useIsUSD;
